import { useEffect } from 'react';
import { useFlagsContextSwitcher } from './hooks';
import { isBarberUser, isBrandUser, isShopUser } from '../session';
import { useReduxSelector } from '../redux-bridge';
import { persistentKVStore } from '../persistence';
export var buildFlagsContextFromUser = function (user, activeShop, barberUser) {
    var _a, _b;
    if (!user) {
        return null;
    }
    // this local storage value is present for user kinds that might have or be assigned to more than one shop
    // such as brands and barbers
    var activeShopId = persistentKVStore.getItem('shop');
    if (isBrandUser(user)) {
        // when there's `shop` in local storage, it means the brand user is currently viewing a shop
        if (activeShopId) {
            return {
                brandId: user.brandId,
                shopId: activeShopId,
            };
        }
        return { brandId: user.brandId };
    }
    var enoughDataToSwitch = !!((_a = user === null || user === void 0 ? void 0 : user.shops) === null || _a === void 0 ? void 0 : _a.length) && !!activeShop;
    if (isShopUser(user) && enoughDataToSwitch) {
        return {
            brandId: activeShop.brandId,
            shopId: activeShop.id,
        };
    }
    enoughDataToSwitch = !!((_b = user.barbers) === null || _b === void 0 ? void 0 : _b.length) && !!barberUser;
    if (isBarberUser(user) && enoughDataToSwitch) {
        return {
            brandId: barberUser.brandId,
            shopId: barberUser.shopId,
            barberId: barberUser.id,
        };
    }
    return null;
};
export var ContextUpdater = function () {
    var user = useReduxSelector('auth.user');
    var activeShop = useReduxSelector('auth.activeShop');
    var barberUser = useReduxSelector('auth.barberUser');
    var switchContext = useFlagsContextSwitcher();
    useEffect(function () {
        var context = buildFlagsContextFromUser(user, activeShop, barberUser);
        switchContext(context);
    }, [user, activeShop, barberUser]);
    return null;
};
